module.exports = __webpack_public_path__ + "static/img/book10.decf847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book10.jpg
// module id = IpmM
// module chunks = 1